import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import * as actions from 'modules/account';
import * as billing from 'modules/billing';
import { injectIntl } from 'react-intl';
import ConfirmForm from './ConfirmForm';
import SupportWidget from '../pages/SupportWidget';

class ShopifyBilling extends Component {
    componentDidMount() {
        SupportWidget();
    }

    render() {
        let { user, dispatch, intl } = this.props;
        const t = (id, values) => intl.formatMessage({ id }, values);
        user.credits = user.credits || 50;

        const planCardStyle = { margin: '5px', minHeight: '480px', padding: '15px', position: 'relative' };
        const professionalCardStyle = { ...planCardStyle, border: '2px solid #0062b1' };
        const isLegacyBilling = !user.billingVersion || user.billingVersion < 2;

        return <div>
            <h3>{t('billing.subscriptionFor')} <b>{user.shopify.shopName}</b></h3>
            {user.profile.subscription !== 'free' ?
                <div>
                    <p>{t('billing.currentlySubscribed')} <b>{user.profile.subscription}</b> {t('billing.plan')}</p>
                    <button type="button" className="btn btn-danger btn-sm" onClick={() => {
                        dispatch(billing.unsubscribe());
                    }
                    }>{t('billing.cancelSubscription')}</button>

                    {user.profile.subscription !== 'professional' && <div style={{marginTop: '20px'}}>
                        <h5>{t('billing.upgradePlan')}</h5>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="panel panel-default" style={{padding: '15px', border: '2px solid #0062b1'}}>
                                    <span style={{position:'absolute', top:'-10px', right:'10px', background:'#0062b1', color:'#fff', padding:'2px 8px', borderRadius:'3px', fontSize:'11px'}}>BEST FOR B2B</span>
                                    <h4 className="text-center">{t('billing.professional')}</h4>
                                    <h5 className="text-center" style={{color:'#333'}}>{t('billing.proPriceMonthly')}</h5>
                                    <p className="text-center"><button type="button" className="btn btn-primary" onClick={() => dispatch(billing.subscribe('professional'))}>{t('billing.upgrade')}</button></p>
                                    <ul>
                                        <li>{t('billing.includesAllStarter')}</li>
                                        <li>{t('billing.proFeature1')}</li>
                                        <li>{t('billing.proFeature2')}</li>
                                        <li>{t('billing.proFeature3')}</li>
                                        <li>{t('billing.proFeature4')}</li>
                                        <li>{t('billing.proFeature5')}</li>
                                        <li>{t('billing.proFeature6')}</li>
                                        <li>{t('billing.proFeature7')}</li>
                                        <li>{t('billing.proFeature8')}</li>
                                        <li>{t('billing.proFeature9')}</li>
                                        <li>{t('billing.proFeature10')}</li>
                                        <li>{t('billing.proFeature11')}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                :
                <div>
                    {t('billing.currentlyUsing')} <b>{t('billing.free')}</b> {t('billing.subscriptionPlan')} <br />
                    <br />
                    <div className="panel panel-default" style={{padding:'15px', marginBottom:'20px'}}>
                        <h5 style={{margin:'0 0 10px'}}>{t('billing.monthlyUsage')}</h5>
                        <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
                            <div style={{flex:1}}>
                                <div style={{background:'#e5e7eb', borderRadius:'4px', height:'8px', overflow:'hidden'}}>
                                    <div style={{background: (user.monthlyGenerated || 0) >= 50 ? '#ef4444' : (user.monthlyGenerated || 0) >= 40 ? '#f59e0b' : '#22c55e', height:'100%', width: Math.min(100, ((user.monthlyGenerated || 0) / 50) * 100) + '%', borderRadius:'4px', transition:'width 0.3s'}}></div>
                                </div>
                            </div>
                            <span style={{fontSize:'13px', fontWeight:'500', color:'#334155', whiteSpace:'nowrap'}}>
                                {t('billing.monthlyGenerated', { count: user.monthlyGenerated || 0 })}
                            </span>
                        </div>
                        {(user.monthlyGenerated || 0) >= 50 && <p style={{color:'#ef4444', fontSize:'12px', marginTop:'8px', marginBottom:'0'}}>
                            {t('billing.monthlyLimitReached')}
                        </p>}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="panel panel-default" style={planCardStyle}>
                                        <h4 className="text-center">{t('billing.freePlan')}</h4>
                                        <h5 className="text-center" style={{color:'#666'}}>{t('billing.freeToInstall')}</h5>
                                        <ul>
                                            <li>{t('billing.freeFeature1')}</li>
                                            <li>{t('billing.freeFeature2')}</li>
                                            <li>{t('billing.freeFeature3')}</li>
                                            <li>{t('billing.freeFeature4')}</li>
                                            <li>{t('billing.freeFeature5')}</li>
                                            <li>{t('billing.freeFeature6')}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="panel panel-default" style={planCardStyle}>
                                        <h4 className="text-center">{t('billing.starterPlan')}</h4>
                                        <h5 className="text-center" style={{color:'#333'}}>{t('billing.starterPrice')}</h5>
                                        {isLegacyBilling && <h6 className="text-center" style={{color:'#999'}}>{t('billing.starterPricePerInvoice')}</h6>}
                                        <p className="text-center"><button type="button" className="btn btn-success" onClick={() => dispatch(billing.subscribe('starter'))}>{t('billing.subscribe')}</button></p>
                                        <ul>
                                            <li><b>{t('billing.starterFeature1')}</b></li>
                                            <li>{t('billing.starterFeature2')}</li>
                                            <li>{t('billing.starterFeature3')}</li>
                                            <li>{t('billing.starterFeature4')}</li>
                                            <li><b>{t('billing.starterFeature5')}</b></li>
                                            <li>{t('billing.starterFeature6')}</li>
                                            <li>{t('billing.starterFeature7')}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="panel panel-default" style={professionalCardStyle}>
                                        <span style={{position:'absolute', top:'-10px', right:'10px', background:'#0062b1', color:'#fff', padding:'2px 8px', borderRadius:'3px', fontSize:'11px'}}>BEST FOR B2B</span>
                                        <h4 className="text-center">{t('billing.professional')}</h4>
                                        <h5 className="text-center" style={{color:'#333'}}>{t('billing.proPriceMonthly')}</h5>
                                        <p className="text-center"><button type="button" className="btn btn-primary" onClick={() => dispatch(billing.subscribe('professional'))}>{t('billing.subscribe')}</button></p>
                                        <ul>
                                            <li>{t('billing.includesAllStarter')}</li>
                                            <li>{t('billing.proTaxOverrides')}</li>
                                            <li>{t('billing.proFeature1')}</li>
                                            <li>{t('billing.proFeature2')}</li>
                                            <li>{t('billing.proFeature3')}</li>
                                            <li>{t('billing.proFeature4')}</li>
                                            <li>{t('billing.proFeature5')}</li>
                                            <li>{t('billing.proFeature6')}</li>
                                            <li>{t('billing.proFeature7')}</li>
                                            <li>{t('billing.proFeature8')}</li>
                                            <li>{t('billing.proFeature9')}</li>
                                            <li>{t('billing.proFeature10')}</li>
                                            <li>{t('billing.proFeature11')}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }
        </div>
    }
}




class ProfileForm extends ConfirmForm {

    componentDidMount() {
        if (typeof window !== "undefined") {
            let windowEl = (function () {
                var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                function scroll() {
                    return { left: scrollLeft, top: scrollTop };
                };
                function scrollLeft() {
                    return window.scrollX || window.pageXOffset || (isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft);
                };
                function scrollTop() {
                    return window.scrollY || window.pageYOffset || (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
                };
                return {
                    scroll: scroll,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                }
            })();

            let handle = setInterval(() => {
                let scrollY = windowEl.scrollTop();
                if (scrollY !== 0)
                    window && window.scrollTo(0, 0);
                else clearInterval(handle);

            }, 800);
        }
    }

    render() {
        let { initialValues, pristine, submitting, handleSubmit, onSubmit, intl, dispatch, accounting, taxes, hasMultipleLocations, locations, profile, themes, currentInvoiceDate } = this.props;

        initialValues.styles = initialValues.styles || {};

        let disabled = pristine || submitting || initialValues.reverting;
        let hasChanges = !disabled;

        return (<div>
            <style>{`

            textarea{
                font-size:10px;
                font-family:Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New;
                background-color: beige;
                border: none;
            }

            `}</style>


            <form onSubmit={handleSubmit(onSubmit)}>
                <ShopifyBilling dispatch={dispatch} user={initialValues} intl={intl} />

                <br />
                <div className={pristine ? "save-panel" : "save-panel visible"}>{intl.formatMessage({ id: 'billing.unsavedChanges' })}</div>
                        {!pristine && <button type="button" onClick={() => location.reload()} className="discard-changes-button btn btn-default btn-sm">{intl.formatMessage({ id: 'billing.discard' })}</button>}
                        <button id="save-changes" style={{
                            position: 'fixed',
                            top: '10px',
                            right: '10px',
                            zIndex: '99999999',
                            opacity: pristine ? 0 : 1
                }} className="btn btn-success btn-sm" type="submit" disabled={pristine || submitting || initialValues.reverting} ><i className="fa fa-check"></i>&nbsp;{intl.formatMessage({ id: 'billing.save' })}</button>
                <i style={{
                    position: 'fixed',
                    top: '20px',
                    left: '13px',
                    zIndex: '99999997',
                    fontSize: '23px',
                    color: 'white'

                }} onClick={() => {
                    window.location.href = '/' + this.props.intl.locale + '/dashboard';
                }
                } className="back-button fa fa-arrow-circle-left">&nbsp;</i>
            </form>


        </div>);
    }
}


ProfileForm.PropTypes = {
    onSubmit: PropTypes.func.isRequired,
}

let ProfileFormComponent = reduxForm({ form: "Profile" })(injectIntl(ProfileForm));
ProfileFormComponent = connect(state => {
    const connectors = selector(state, 'connectors');
    const accounting = selector(state, 'accounting');
    const taxes = selector(state, 'taxes');
    const hasMultipleLocations = selector(state, 'hasMultipleLocations');
    const locations = selector(state, 'locations');
    const themes = selector(state, 'themes');

    const currentInvoiceDate = selector(state, 'currentInvoiceDate');
    return {
        connectors,
        accounting,
        currentInvoiceDate,
        hasMultipleLocations,
        locations,
        themes,
        taxes
    }
})(ProfileFormComponent)
const selector = formValueSelector('Profile');

class Profile extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let { dispatch } = this.props;

        dispatch(actions.fetchAccount());
    }

    onSubmit(account) {
        let { dispatch } = this.props;
        dispatch(actions.updateAccount(account));
    }
    render() {

        let { account, intl, profile } = this.props;

        if (!account || !account.email) {
            return <div style={{
                position: 'absolute',
                top: '0',
                left: '50%'
            }}>{intl.formatMessage({ id: 'common.loading' })}</div>
        }

        return <div className="container-fluid">
            <div className="sidebar">
                <div className="col-md-10">
                    <span style={{ marginLeft: '23px' }}>{intl.formatMessage({ id: 'billing.title' })}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-lg-12 col-xs-12">

                    <ProfileFormComponent onSubmit={this.onSubmit.bind(this)} initialValues={account} profile={profile} />

                </div>
            </div>
        </div>

    }
}

Profile.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        ...state.user,
        account: {
            ...state.account
        },
        profile: state.form.Profile ? state.form.Profile.values : {},
    };
}

export default injectIntl(connect(mapStateToProps)(Profile));



// WEBPACK FOOTER //
// app/containers/Billing.jsx